<template>
  <main-logo-register />

  <FormCard :image-src="workspaceData?.picture" title="¡Ya casi estamos listos!">
    <password-user-invite
      v-model:value="password"
      :isChangePassword="isChangePassword"
      @setPassword="setPassword"
    />

    <a-row :gutter="24" class="actions">
      <a-col :span="5" v-if="!isChangePassword">
        <a-button class="button" @click="handleBackWindowns"> Volver </a-button>
      </a-col>
      <a-col :span="isChangePassword ? 24 : 19">
        <a-button
          class="button"
          type="primary"
          @click="handleCreateUser"
          :disabled="password === ''"
          :loading="loading"
        >
          Guardar e Iniciar
        </a-button>
      </a-col>
    </a-row>
  </FormCard>
</template>

<script>
import { defineComponent } from "vue";

import { useValidateWorkspace } from "@/app/auth/composables/useValidateWorkspace";

import MainLogoRegister from "@/app/shared/components/molecules/MainLogoRegister.vue";
import PasswordUserInvite from "@/app/auth/components/organisms/PasswordUserInvite.vue";
import FormCard from "@/app/auth/components/atoms/FormCard.vue";

export default defineComponent({
  components: {
    PasswordUserInvite,
    MainLogoRegister,
    FormCard,
  },
  data() {
    return {
      loading: false,
      password: "",
      workspace: "",
    };
  },
  setup() {
    const workspaceData = useValidateWorkspace();

    return { workspaceData };
  },
  computed: {
    name() {
      return this.$store.getters["getNewUserInvite"];
    },
    isChangePassword() {
      return this.$route.query.changePassword === "true";
    },
  },
  methods: {
    setPassword($event) {
      this.password = $event;
    },
    async handleCreateUser() {
      try {
        this.loading = true;
        if (!this.password) return;
        const token = this.$route.params.token;
        const data = {
          token: token,
          password: this.password,
        };
        await this.$store.dispatch("createNewUserInvite", data);
        this.$store.dispatch("fetchAllUsers");
        this.loading = false;
        this.$router.push("/login");
      } catch (error) {
        this.loading = false;
        this.$message.error("Error al registrarte");
      }
    },
    handleBackWindowns() {
      this.$store.dispatch("setRegisterStep", 1);
    },
  },
});
</script>

<style lang="sass" scoped>


.container
  width: 30%

.drawing
  margin-top: 50px
  width: 30%
  text-align: center

.container__info
  margin: 0 auto
  margin-top: 50px
  text-align: center
  margin-bottom: 50px

.name
  font-weight: 600
  font-size: 30px

.subtitle
  font-size: 20px

.separator
  margin-bottom: 30px

.button
  width: 100%

.text--plan
  font-size: 20px
  font-weight: 400
  margin-top: -20px

.flex
  display: flex
  justify-content: space-around

.actions
  margin-top: 32px
</style>
